/* ============================================================
   Anker Nano Power Bank (MagGo, Plus) — A1113 LP
   Pure JS. アニメ/タブ/レーダー演出。
   ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('.page-anker-nlb-maggoplus');
  if (!root) return;

  const prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. IntersectionObserver for [data-anim] ---------- */
  const animTargets = root.querySelectorAll('[data-anim]');

  if (prefersReducedMotion) {
    animTargets.forEach((el) => el.classList.add('is-in'));
  } else {
    // delay 設定
    // - hero-bg:       0ms (即時)
    // - hero-1,2,3:    250ms ずつスタガード (250 / 500 / 750)
    // - hero-qi2:      1500ms (テキスト後の余韻)
    // - brand-l:       0ms
    // - brand-r:       300ms (左→右の流れ)
    animTargets.forEach((el) => {
      const key = el.getAttribute('data-anim') || '';

      let delay = 0;
      const m = key.match(/^hero-(\d+)$/);
      if (m) {
        delay = parseInt(m[1], 10) * 300; // hero-1=300, hero-2=600, hero-3=900 (Figma指示: 0.3s間隔)
      } else if (key === 'hero-qi2') {
        delay = 1500;
      } else if (key === 'brand-r') {
        delay = 300;
      }
      if (delay) el.style.transitionDelay = `${delay}ms`;
    });

    // Hero は即時 in (ファーストビュー固定)
    // ただし KV 背景画像のロード完了を待つ。回線が遅いとアニメだけ先に終わって
    // ユーザーに見えないため、bg img の load / error を待ってから発火。
    // 最悪のフォールバックとして 2.5s 経過で強制発火。
    const heroEls = root.querySelectorAll('.anker-nlb-maggoplus-hero [data-anim]');
    const triggerHero = () => {
      requestAnimationFrame(() => {
        heroEls.forEach((el) => el.classList.add('is-in'));
      });
    };
    const heroBgImg = root.querySelector('.anker-nlb-maggoplus-hero-bg img');
    if (!heroBgImg || heroBgImg.complete) {
      triggerHero();
    } else {
      let fired = false;
      const fire = () => { if (fired) return; fired = true; triggerHero(); };
      heroBgImg.addEventListener('load', fire, { once: true });
      heroBgImg.addEventListener('error', fire, { once: true });
      setTimeout(fire, 2500);
    }

    // それ以外は IntersectionObserver
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    animTargets.forEach((el) => {
      if (!el.closest('.anker-nlb-maggoplus-hero')) observer.observe(el);
    });
  }

  /* ---------- 2. Smooth scroll for anchor links (5つの理由 index) ---------- */
  root.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href');
    if (id.length < 2) return;
    const target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- 3. 商品カラー切替 (画像差替 + active 状態) ---------- */
  root.querySelectorAll('.anker-nlb-maggoplus-product-inner, .anker-nlb-maggoplus-product-bottom-inner').forEach((container) => {
    const radios = container.querySelectorAll('.anker-nlb-maggoplus-product-color');
    const productImage = container.querySelector('.anker-nlb-maggoplus-product-image');
    if (!radios.length) return;
    radios.forEach((radio) => {
      radio.addEventListener('click', () => {
        const color = radio.dataset.color || 'black';
        radios.forEach((r) => {
          const isActive = r === radio;
          r.classList.toggle('is-active', isActive);
          r.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
        if (productImage) productImage.dataset.current = color;
      });
    });
  });

  /* ---------- 4. Reason 5-1: 試験タブ切替 (auto-cycle + manual) ---------- */
  const tabRoot = root.querySelector('.anker-nlb-maggoplus-reason-01');
  if (tabRoot) {
    const tabs = tabRoot.querySelectorAll('.anker-nlb-maggoplus-tab');
    const panels = tabRoot.querySelectorAll('.anker-nlb-maggoplus-reason-01-desc');
    const cellPairs = tabRoot.querySelectorAll('.anker-nlb-maggoplus-reason-01-cell-pair');
    let activeIdx = 0;
    let autoTimer = null;
    let userInteracted = false;

    const resetGauges = () => {
      tabs.forEach((t) => {
        const g = t.querySelector('.anker-nlb-maggoplus-tab-gauge');
        if (g) g.classList.remove('is-filling');
      });
    };
    const triggerActiveGauge = () => {
      const g = tabs[activeIdx] && tabs[activeIdx].querySelector('.anker-nlb-maggoplus-tab-gauge');
      if (!g) return;
      // Force reflow so the transition restarts
      void g.offsetWidth;
      requestAnimationFrame(() => g.classList.add('is-filling'));
    };

    const setActive = (idx, withGauge) => {
      activeIdx = idx;
      tabs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      panels.forEach((p, i) => {
        if (i === idx) { p.removeAttribute('hidden'); }
        else { p.setAttribute('hidden', ''); }
      });
      cellPairs.forEach((pair, i) => {
        const pairVideos = pair.querySelectorAll('video');
        if (i === idx) {
          pair.removeAttribute('hidden');
          pairVideos.forEach((v) => { try { v.currentTime = 0; v.play(); } catch (_) {} });
        } else {
          pair.setAttribute('hidden', '');
          pairVideos.forEach((v) => { try { v.pause(); } catch (_) {} });
        }
      });
      resetGauges();
      if (withGauge) triggerActiveGauge();
    };

    const stopAuto = () => {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      resetGauges();
    };
    const startAuto = () => {
      stopAuto();
      // 即時 1本目のゲージを発火
      triggerActiveGauge();
      autoTimer = setInterval(() => {
        if (userInteracted) return;
        setActive((activeIdx + 1) % tabs.length, true);
      }, 4000);
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        userInteracted = true;
        stopAuto();
        setActive(i, false);
      });
    });

    // 試験ブロックが画面に入ったら自動再生開始
    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      const tabObserver = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { startAuto(); }
          else { stopAuto(); }
        });
      }, { threshold: 0.3 });
      tabObserver.observe(tabRoot);
    }
  }

  /* ---------- 5. Reason 5-5 (総合): スペック比較ループ ----------
     1. 通常モバイルバッテリーの spec が左ゲージ + 右レーダーに表示
     2. その上に NLB 搭載モバイルバッテリーの spec が上塗り表示
     3. リセット → 繰り返し (約 5.5s 周期)
  ---------------------------------------------------------------- */
  const r05 = root.querySelector('.anker-nlb-maggoplus-reason-05');
  if (r05 && !prefersReducedMotion) {
    let cycleHandle = null;
    const timers = [];
    const clearTimers = () => { timers.forEach(clearTimeout); timers.length = 0; };

    const runCycle = () => {
      clearTimers();
      r05.classList.remove('is-show-normal', 'is-show-nlb');
      timers.push(setTimeout(() => r05.classList.add('is-show-normal'), 200));
      timers.push(setTimeout(() => r05.classList.add('is-show-nlb'),    1500));
      timers.push(setTimeout(() => {
        r05.classList.remove('is-show-normal', 'is-show-nlb');
      }, 4500));
      cycleHandle = setTimeout(runCycle, 5500);
      timers.push(cycleHandle);
    };

    const stopCycle = () => {
      clearTimers();
      r05.classList.remove('is-show-normal', 'is-show-nlb');
    };

    if ('IntersectionObserver' in window) {
      const r05Observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) runCycle();
          else stopCycle();
        });
      }, { threshold: 0.3 });
      r05Observer.observe(r05);
    } else {
      runCycle();
    }
  }

  /* ---------- 6. Scroll progress tracker (Hero パララックス) ----------
     [data-scroll-bind] が付いた要素について、要素の上端が viewport top に
     到達してから要素 1 つ分スクロールするまでを 0→1 にマップし、
     --scroll-progress カスタムプロパティに書き戻す。
  ---------------------------------------------------------------- */
  const scrollBindTargets = root.querySelectorAll('[data-scroll-bind]');
  if (scrollBindTargets.length && !prefersReducedMotion) {
    let ticking = false;
    const update = () => {
      ticking = false;
      scrollBindTargets.forEach((el) => {
        const rect = el.getBoundingClientRect();
        // 要素 top が viewport top を通過してから要素高さ分スクロール → 1.0
        const denom = rect.height || 1;
        let progress = -rect.top / denom;
        if (progress < 0) progress = 0;
        else if (progress > 1) progress = 1;
        el.style.setProperty('--scroll-progress', progress.toFixed(3));
      });
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- 7. altmat-deco scroll scale ----------
     結論ブロック [data-altmat-outro] が viewport に近づくにつれて
     左カラム sticky の NLB ロゴを徐々に拡大 (1 → 1.55)。
     outro top が vh*0.9 を超えたとき 0、vh*0.3 を切ったとき 1。
  ---------------------------------------------------------------- */
  const altmatOutro   = root.querySelector('[data-altmat-outro]');
  const altmatWeight  = root.querySelector('[data-altmat-weight]');
  const altmatSection = root.querySelector('[data-section="altmat"]');
  if (altmatSection && !prefersReducedMotion) {
    let ticking = false;
    const updateDeco = () => {
      ticking = false;
      const vh = window.innerHeight || 1;

      // 拡大 + bg 反転 progress (outro 進行で 0→1)
      if (altmatOutro) {
        const rect = altmatOutro.getBoundingClientRect();
        const startY = vh * 0.9;
        const endY   = vh * 0.3;
        let p = (startY - rect.top) / (startY - endY);
        if (p < 0) p = 0;
        else if (p > 1) p = 1;
        altmatSection.style.setProperty('--deco-progress', p.toFixed(3));
      }

      // 見出しフェードアウト progress (重量セクションを読み終わる頃に 0→1)
      if (altmatWeight) {
        const rect = altmatWeight.getBoundingClientRect();
        // 記事 top が vh*0.1 (画面上端付近) 到達で開始、bottom が vh*0.3 (画面中央上) で完了
        const startY = vh * 0.1;
        const endY   = -rect.height * 0.4;
        let f = (startY - rect.top) / (startY - endY);
        if (f < 0) f = 0;
        else if (f > 1) f = 1;
        altmatSection.style.setProperty('--heading-fade', f.toFixed(3));
      }
    };
    const onScrollDeco = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateDeco);
    };
    window.addEventListener('scroll', onScrollDeco, { passive: true });
    window.addEventListener('resize', onScrollDeco, { passive: true });
    updateDeco();
  }

  /* ---------- 8. KV Videos (3本) ----------
     全動画を 1大+2小 グリッドで同時表示。
     軽量化:
       - <video preload="none">
       - 初回可視時のみ src 注入 + play
       - off-screen 時は pause */
  const kvSection = root.querySelector('[data-section="kv-videos"]');
  if (kvSection) {
    const slots = Array.from(kvSection.querySelectorAll('.anker-nlb-maggoplus-kv-video'));

    const setLoading = (slot, on) => slot.classList.toggle('is-loading', on);

    const attachSrc = (slot) => {
      const v = slot.querySelector('video');
      if (!v) return;
      if (v.dataset.kvSrc && !v.getAttribute('src')) {
        setLoading(slot, true);
        v.addEventListener('playing', () => setLoading(slot, false));
        v.addEventListener('canplay',  () => setLoading(slot, false));
        v.addEventListener('waiting',  () => setLoading(slot, true));
        v.addEventListener('stalled',  () => setLoading(slot, true));
        v.addEventListener('error',    () => setLoading(slot, false));
        v.setAttribute('src', v.dataset.kvSrc);
        v.load();
      }
    };
    const playSlot = (slot) => {
      const v = slot.querySelector('video');
      if (v && v.paused) v.play().catch(() => {});
    };
    const pauseSlot = (slot) => {
      const v = slot.querySelector('video');
      if (v && !v.paused) v.pause();
    };

    const ioKv = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            slots.forEach((s) => { attachSrc(s); playSlot(s); });
          } else {
            slots.forEach(pauseSlot);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );
    ioKv.observe(kvSection);
  }

})();
